import React from "react";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import "./App.css";
import { Route, Switch } from "react-router-dom";
import { Router } from "react-router";

//import { history } from './index';
import history from "./history";

import DialogsRoot from "./containers/dialogs_root";
import CallbackPage from "./components/callback_page";
import CallbackPageKD from "./components/callback_page_kd";
import Loading from "./components/utils/Loading";
import Main from "./containers/main";
import IlusionaHeader from "./containers/ilusiona_header";
import LeftDrawer from "./containers/left_drawer";

import IniMiMuro from "./containers/ini_mi_muro";
import IniMiMuroKD from "./containers/ini_mi_muro_kd";
import IniNoticias from "./containers/ini_noticias";
import IniVentas from "./containers/ini_ventas";
import IniArcades from "./containers/ini_arcades";
import IniCierres from "./containers/ini_cierres";
import IniCierresKD from "./containers/ini_cierres_kd";
import IniVentasKD from "./containers/ini_ventas_kd";
import IniDesconexion from "./containers/ini_desconexion";
import KDImportar from "./containers/acc_kd_importar";
import MaeAuxiliaresTipoZona from "./containers/mae_auxiliares_tipo_zona/mae_auxiliares_tipo_zona";
import MaeAuxiliaresGrupoPartida from "./containers/mae_auxiliares_grupo_partida/mae_auxiliares_grupo_partida";
import MaeAuxiliaresTipoMaquina from "./containers/mae_auxiliares_tipo_maquina/mae_auxiliares_tipo_maquina";
import MaeAuxiliaresModeloMaquina from "./containers/mae_auxiliares_modelo_maquina/mae_auxiliares_modelo_maquina.js";
import MaeAuxiliaresTipoPartida from "./containers/mae_auxiliares_tipo_partida/mae_auxiliares_tipo_partida";
import MaeAuxiliaresTipoArticulo from "./containers/mae_auxiliares_tipo_articulos/mae_auxiliares_tipo_articulos";
import MaeAuxiliaresTipoGasto from "./containers/mae_auxiliares_tipo_gasto/mae_auxiliares_tipo_gasto";
import MaeAuxiliaresTipoZonaIVA from "./containers/mae_auxiliares_tipo_zona_iva/mae_auxiliares_tipo_zona_iva";
import MaeAuxiliaresPerfilesUsuario from "./containers/mae_auxiliares_perfiles_usuario/mae_auxiliares_perfiles_usuario";
import UsuarioEdit from "./containers/mae_auxiliares_perfiles_usuario/usuario_edit";

import MaeEmpresa from "./containers/mae_empresa/mae_empresa";
import EmpresaEdit from "./containers/mae_empresa/empresa_edit";
import MaeCentro from "./containers/mae_centro/mae_centro";
import CentroEdit from "./containers/mae_centro/centro_edit";
import MaeZona from "./containers/mae_zona/mae_zona";
import ZonaEdit from "./containers/mae_zona/zona_edit";
import MaeMaquina from "./containers/mae_maquina/mae_maquina";
import MaquinaEdit from "./containers/mae_maquina/maquina_edit";

import AccCierreDiario from "./containers/acc_cierre_diario/acc_cierre_diario";
import MoverMaquina from "./containers/acc_mover_maquinas/acc_mover_maquinas";
import AccCierreSemanal from "./containers/acc_cierre_semanal/acc_cierre_semanal";
import ExportarContabilidad from "./containers/acc_exportar_contabilidad/acc_exportar_contabilidad";
import DesbloquearContabilidad from "./containers/acc_desbloquear_contabilidad/acc_desbloquear_contabilidad";

import EntGastos from "./containers/ent_gastos/ent_gastos";
import EntMkt from "./containers/ent_mkt/ent_mkt";
import EntLecturaMaqCambio from "./containers/ent_lectura_maq_cambio/ent_lectura_maq_cambio";
import EntPartidasPorTipo from "./containers/ent_partidas_por_tipo/ent_partidas_por_tipo";
import EntLecturaMaqArcade from "./containers/ent_lectura_maq_arcade/ent_lectura_maq_arcade";
import EntIngresosBanco from "./containers/ent_ingresos_banco/ent_ingresos_banco";
import EntPresupuestos from "./containers/ent_presupuestos/ent_presupuestos";
import PresupuestoDetalle from "./containers/ent_presupuestos/presupuesto_detalle";
import EntAlertas from "./containers/ent_alertas/ent_alertas";

import InfResumenDiario from "./containers/inf_resumen_diario/inf_resumen_diario";
import InfResumenSemanal from "./containers/inf_resumen_semanal/inf_resumen_semanal";
import InfResumenVentas from "./containers/inf_resumen_ventas/inf_resumen_ventas";
import InfVentas from "./containers/inf_ventas/inf_ventas";
import InfArcade from "./containers/inf_arcade/inf_arcade";
import InfRedemption from "./containers/inf_redemption/inf_redemption.js";
import InfDiasAnyo from "./containers/inf_dias_anyo/inf_dias_anyo";
import InfDescuadresCaja from "./containers/inf_descuadres_caja/inf_descuadres_caja";

import TestComponent from "./containers/test_component";

import MaeAuxiliaresFamilia from "./containers/mae_redemption_familia/mae_redemption_familia";
import MaeAuxiliaresSubFamilia from "./containers/mae_redemption_sub_familia/mae_redemption_sub_familia";
import MaeAuxiliaresTipoFicha from "./containers/mae_redemption_tipo_ficha/mae_redemption_tipo_ficha";
import MaeAuxiliaresTipoFichaSub from "./containers/mae_redemption_tipo_ficha_sub/mae_redemption_tipo_ficha_sub";
import MaeAuxiliaresTipoMovRedem from "./containers/mae_redemption_tipo_mov_redem/mae_redemption_tipo_mov_redem";
import MaePromocion from "./containers/mae_redemption_promocion/mae_redemption_promocion";
import MaeAuxiliaresMotivo from "./containers/mae_redemption_motivo/mae_redemption_motivo";
import MaeArticulo from './containers/mae_redemption_articulo/mae_redemption_articulo';
import ArticuloEdit from './containers/mae_redemption_articulo/articulo_edit';

import MaeSegmentacion from './containers/mae_redemption_segmentacion/mae_redemption_segmentacion';

import EntPedido from "./containers/ent_pedido/ent_pedido";
import EntPedidoPdte from "./containers/ent_albaran_pdte/ent_albaran_pdte";
import AccInventario from "./containers/acc_inventario/acc_inventario";
import EntAlbaranHist from "./containers/ent_albaran_hist/ent_albaran_hist";

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#e8f1d7",
      main: "#8dbb35",
      dark: "689f38"
    },
    secondary: {
      light: "#ecd7e8",
      main: "#a2398d",
      dark: "#872373"
    },
    background: {
      paper: "#fff",
      default: "#e0e0e0"
    }
  },
  status: {
    danger: "orange"
  },
  typography: {
    useNextVariants: true
  }
});

function App() {
   return (
    <MuiThemeProvider theme={theme}>
      <DialogsRoot />
      <Loading />
      <Router history={history}>
        <div>
          <IlusionaHeader />
          <div style={{ display: "flex" }}>
            <LeftDrawer />
            <Switch>
              <Route path="/callback.html" component={CallbackPage} />
              <Route path="/callback_kd.html" component={CallbackPageKD} />
              {/* <Route path="/silent_renew.html" component={SilentRenew} /> */}
              <Route path="/ini_mi_muro" component={IniMiMuro} />
              <Route path="/ini_mi_muro_kd" component={IniMiMuroKD} />
              <Route path="/ini_noticias" component={IniNoticias} />
              <Route path="/ini_ventas" component={IniVentas} />
              <Route path="/ini_arcades" component={IniArcades} />
              <Route path="/ini_cierres" component={IniCierres} />
              <Route path="/ini_cierres_kd" component={IniCierresKD} />
              <Route path="/ini_ventas_kd" component={IniVentasKD} />
              <Route path="/ini_desconexion" component={IniDesconexion} />
              <Route path="/ini_importar_kd" component={KDImportar} />
              <Route
                path="/mae_auxiliares_tipo_zona"
                component={MaeAuxiliaresTipoZona}
              />
              <Route
                path="/mae_auxiliares_grupo_partida"
                component={MaeAuxiliaresGrupoPartida}
              />
              <Route
                path="/mae_auxiliares_tipo_partida"
                component={MaeAuxiliaresTipoPartida}
              />
              <Route
                path="/mae_auxiliares_tipo_maquina"
                component={MaeAuxiliaresTipoMaquina}
              />
              <Route
                path="/mae_auxiliares_modelo_maquina"
                component={MaeAuxiliaresModeloMaquina}
              />
              <Route
                path="/mae_auxiliares_tipo_articulo"
                component={MaeAuxiliaresTipoArticulo}
              />
              <Route
                path="/mae_auxiliares_tipo_gasto"
                component={MaeAuxiliaresTipoGasto}
              />
              <Route
                path="/mae_auxiliares_tipo_zona_iva"
                component={MaeAuxiliaresTipoZonaIVA}
              />
              <Route
                path="/mae_auxiliares_perfiles_usuario"
                component={MaeAuxiliaresPerfilesUsuario}
              />
              <Route path="/edit_usuario/:id" component={UsuarioEdit} />
              <Route path="/mae_empresa" component={MaeEmpresa} />
              <Route path="/edit_empresa/:id" component={EmpresaEdit} />
              <Route path="/mae_centro" component={MaeCentro} />
              <Route path="/edit_centro/:id" component={CentroEdit} />
              <Route path="/mae_zona" component={MaeZona} />
              <Route path="/edit_zona/:id" component={ZonaEdit} />
              <Route path="/mae_maquina" component={MaeMaquina} />
              <Route path="/edit_maquina/:id" component={MaquinaEdit} />

              <Route path="/ini_test" component={TestComponent} />

              <Route path="/acc_cierre_diario" component={AccCierreDiario} />
              <Route path="/acc_cierre_semanal" component={AccCierreSemanal} />
              <Route
                path="/acc_exportar_contabilidad"
                component={ExportarContabilidad}
              />
              <Route path="/acc_mover_maquinas" component={MoverMaquina} />
              <Route
                path="/acc_desbloquear_contabilidad"
                component={DesbloquearContabilidad}
              />

              <Route path="/ent_gastos" component={EntGastos} />
              <Route path="/ent_mkt" component={EntMkt} />
              <Route
                path="/ent_lectura_maq_cambio"
                component={EntLecturaMaqCambio}
              />
              <Route
                path="/ent_partidas_por_tipo"
                component={EntPartidasPorTipo}
              />
              <Route
                path="/ent_lectura_maq_arcade"
                component={EntLecturaMaqArcade}
              />
              <Route path="/ent_ingresos_banco" component={EntIngresosBanco} />
              <Route path="/ent_presupuestos" component={EntPresupuestos} />
              <Route
                path="/presupuesto_detalle/:id"
                component={PresupuestoDetalle}
              />
              <Route path="/ent_alertas" component={EntAlertas} />

              <Route path="/inf_resumen_diario" component={InfResumenDiario} />
              <Route
                path="/inf_resumen_semanal"
                component={InfResumenSemanal}
              />
              <Route path="/inf_resumen_ventas" component={InfResumenVentas} />
              <Route path="/inf_ventas" component={InfVentas} />
              <Route path="/inf_arcade" component={InfArcade} />
              <Route path="/inf_redemption" component={InfRedemption} />
              <Route path="/inf_dias_anyo" component={InfDiasAnyo} />
              <Route
                path="/inf_descuadres_caja"
                component={InfDescuadresCaja}
              />

              <Route
                path="/mae_redemption_familia"
                component={MaeAuxiliaresFamilia}
              />
              <Route
                path="/mae_redemption_sub_familia"
                component={MaeAuxiliaresSubFamilia}
              />
              <Route
                path="/mae_redemption_tipo_ficha"
                component={MaeAuxiliaresTipoFicha}
              />
              <Route
                path="/mae_redemption_tipo_ficha_sub"
                component={MaeAuxiliaresTipoFichaSub}
              />
              <Route
                path="/mae_redemption_tipo_mov_redem"
                component={MaeAuxiliaresTipoMovRedem}
              />
              <Route
                path="/mae_redemption_promocion"
                component={MaePromocion}
              />
              <Route
                path="/mae_redemption_motivo"
                component={MaeAuxiliaresMotivo}
              />
              <Route path="/mae_redemption_articulo" component={MaeArticulo} />
              <Route path="/edit_articulo/:id" component={ArticuloEdit} />

              <Route path="/mae_redemption_segmentacion" component={MaeSegmentacion} />

              <Route path="/ent_pedido" component={EntPedido} />
              <Route path="/ent_albaran_pdte" component={EntPedidoPdte} />
              <Route path="/acc_inventario" component={AccInventario} />
              <Route path="/ent_albaran_hist" component={EntAlbaranHist} />

              <Route path="/" component={Main} />
            </Switch>
          </div>
        </div>
      </Router>
    </MuiThemeProvider>
  );
}

export default App;
